module.exports = __webpack_public_path__ + "img/team12.f10159ac.jpg";